import axios from 'axios';
import bsCustomFileInput from 'bs-custom-file-input';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { Button, Col, Fade, Form, Spinner } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { CampoFormik } from '../../../components/CompUtils';
import Dialog from '../../../components/CompUtils/Dialog';
import { finalize, init } from '../../../components/GlobalFeedback/feedbackSlice';
import { GREMIOS, USERAPI } from '../../../const';
import es from '../../../yup-es';

const useStyles = createUseStyles({
  footerContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    width: '100%',
  },
  footerError: {
    display: 'block',
    justifySelf: 'flex-start',
    textAlign: 'center',
  },
});
const NuevoMiembroComite = ({
  show,
  title,
  size = 'lg',
  onClose = null,
  onNuevoMiembro = null,
  showRepresentacion = null,
}) => {
  const classes = useStyles();
  const [error, setError] = useState(null);

  const nuevoMiembro = (miembro) => {
    onNuevoMiembro?.(miembro);
  };

  const handleAjaxError = (errorResp) => {
    const customMsg = errorResp.data.message || 'Error al conectarse con el servidor';
    setError(('' + errorResp.status).startsWith('4') ? customMsg : 'Error en el servidor');
  };

  const handleClose = () => {
    setError(null);
    onClose?.();
  };
  return (
    <Dialog
      show={show}
      title={title}
      size={size}
      handleClose={handleClose}
      footer={
        <div className={classes.footerContainer}>
          {error && (
            <Form.Control.Feedback className={classes.footerError} type="invalid">
              {error}
            </Form.Control.Feedback>
          )}
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            type="submit"
            form="nuevoMiembroComite"
            variant="success"
            onClick={() => setError(null)}>
            Guardar
          </Button>
        </div>
      }>
      <MiembroForm
        onSubmit={(miembro) => nuevoMiembro(miembro)}
        onAjaxError={handleAjaxError}
        showRepresentacion={showRepresentacion}
      />
    </Dialog>
  );
};

export const MiembroForm = ({ onSubmit, onAjaxError, showRepresentacion }) => {
  const dispatch = useDispatch(); //Para los casos de creación de usuario, despachar loading
  const [ajaxFeedback, setAjaxFeedbackState] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [uploadCv, setUploadCv] = useState(false);
  const [miembroData, setMiembroData] = useState(null);
  useEffect(() => {
    bsCustomFileInput.init();
  }, []);

  const setAjaxFeedback = (state) => {
    setAjaxFeedbackState(state);
    setTimeout(() => {
      setAjaxFeedbackState(false);
    }, 500);
  };

  yup.setLocale(es);
  const schema = yup.object({
    titular: yup.number().nullable().min(0).max(1).required(),
    idUsuario: yup.number(),
    dni: yup.number().required(),
    cuil: yup.number().required(),
    apellido: yup.string().required(),
    nombre: yup.string().required(),
    email: yup.string().required().email(),
    telefono: yup.string().required(),
    representacion: yup.string(),
    cv: yup.string().required(),
    // cv: yup
    //   .mixed()
    //   .test(
    //     'fileType',
    //     'Tipo de archivo no soportado',
    //     (value) => !value || validarTipoArchivoPermitido(value),
    //   ),
  });

  const initial = {
    idUsuario: '',
    titular: null,
    dni: '',
    cuil: '',
    apellido: '',
    nombre: '',
    email: '',
    telefono: '',
    representacion: '',
    cv: {},
  };

  const handleSearch = (formik) => {
    //Realizo manualmente la validación, al buscar por cuil (cuil obligatorio)
    formik.setFieldTouched('cuil');
    if (formik.errors.cuil) return false;

    const cuil = formik.values.cuil;

    setAjaxFeedbackState('pending');
    setDisabled(true);

    axios
      .get(`${USERAPI}/usuarios/cuil/${cuil}`)
      .then((res) => {
        setAjaxFeedback('success');

        const data = res.data;
        formik.resetForm({
          values: {
            ...initial,
            titular: formik.values.titular,
            cuil: data.cuil,
            dni: data.dni,
            idUsuario: data.idUsuario,
            apellido: data.apellido,
            nombre: data.nombre,
            email: data.email,
            telefono: data.telefono,
            cv: data.pathCvProvisto,
            representacion: formik.values.representacion,
          },
          errors: {},
        });
        setMiembroData(data);
        setUploadCv(true);
      })
      .catch((error) => {
        setAjaxFeedback(null);
        //Reseteo el formulario por las dudas, pero reestablezco el cuil y el bool de titular
        formik.resetForm({
          values: { ...initial, cuil, titular: formik.values.titular },
        });
        formik.setFieldError(
          'cuil',
          'Usuario no encontrado. Realizar registro en el siguiente formulario',
        );
        setMiembroData(initial);
        setDisabled(false);
        setUploadCv(true);
      });
  };

  const handleSubmit = (formikValues, action) => {
    const titular = !!parseInt(formikValues.titular);

    const copy = { ...formikValues };
    let sendData = {
      idUsuario: miembroData?.idUsuario || 0,
      titular,
      dni: miembroData?.dni || formikValues.dni,
      cuil: miembroData?.cuil || formikValues.cuil,
      apellido: miembroData?.apellido || formikValues.apellido,
      nombre: miembroData?.nombre || formikValues.nombre,
      email: miembroData?.email || formikValues.email,
      telefono: miembroData?.telefono || formikValues.telefono,
      representacion: formikValues.representacion || '',
      cv: miembroData?.pathCvProvisto || copy.cv,
    };

    const filenameCvMiembro = miembroData.pathCvProvisto
      ? miembroData.pathCvProvisto.replace(/^.*[\\/]/, '')
      : '';

    let filenameCvCopy = '';
    if (copy.cv) {
      filenameCvCopy = copy.cv.name
        ? copy.cv.name.replace(/^.*[\\/]/, '')
        : copy.cv.replace(/^.*[\\/]/, '');
    }

    if (!formikValues.idUsuario) {
      const formData = new FormData();

      if (copy.cv) {
        formData.append('cv', copy.cv);
        delete copy.cv;
      }

      delete copy.titular;
      formData.append('userData', JSON.stringify(copy));

      dispatch(init());
      axios
        .post(`${USERAPI}/auth/signup-simple`, formData)
        .then((resp) => {
          sendData = trasformarAMiembroTable(resp.data);
          onSubmit?.({ ...sendData, titular });
          dispatch(finalize());
        })
        .catch((error) => {
          onAjaxError(error.response);
        })
        .finally(() => dispatch(finalize()));
    } else if (
      (!miembroData.pathCvProvisto && copy.cv && formikValues.idUsuario) ||
      (miembroData.pathCvProvisto &&
        copy.cv &&
        formikValues.idUsuario &&
        filenameCvMiembro !== filenameCvCopy)
    ) {
      const formDataCv = new FormData();
      formDataCv.append('file', copy.cv);
      formDataCv.append('cuil', copy.cuil);

      axios
        .post(`${USERAPI}/auth/upload`, formDataCv)
        .then((resp) => {
          sendData.cv = copy.cv.name;
          miembroData.pathCvProvisto = copy.cv.name;
          onSubmit?.({ ...sendData, titular });
          dispatch(finalize());
        })
        .catch((error) => {
          onAjaxError(error.response);
        });
    } else {
      onSubmit?.({ ...sendData, titular });
    }
  };

  function trasformarAMiembroTable(datos) {
    const data = {
      apellido: datos.apellido,
      cuil: datos.cuil,
      cv: datos.pathCvProvisto,
      email: datos.email,
      idUsuario: datos.idUsuario,
      nombre: datos.nombre,
      representacion: datos.representacion,
      telefono: datos.telefono,
      titular: datos.titular,
    };

    setMiembroData(data);
    return data;
  }
  return (
    <Formik
      validationSchema={schema}
      validateOnChange={false}
      initialValues={initial}
      onSubmit={handleSubmit}>
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit} id="nuevoMiembroComite">
          <Form.Row>
            <Form.Group className="align-self-center" as={Col}>
              {[
                { key: 1, desc: 'Titular' },
                { key: 0, desc: 'Alterno' },
              ].map((el) => (
                <Form.Check inline key={el.key}>
                  <Form.Check.Input
                    type="radio"
                    name="titular"
                    // defaultChecked={el.key === 1}
                    value={el.key}
                    onBlur={formik.handleBlur}
                    isInvalid={!!formik.errors.titular}
                    onChange={(ev) => {
                      formik.setFieldValue('titular', ev.target.value);
                    }}
                  />
                  <Form.Check.Label>{el.desc}</Form.Check.Label>
                </Form.Check>
              ))}
              <Form.Control.Feedback
                style={{ display: formik.errors.titular ? 'block' : 'none' }}
                type="invalid">
                {formik.errors.titular}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col}>
              {showRepresentacion && (
                <CampoFormik
                  //col={{ sm: 6 }}
                  type="select"
                  label="Representación"
                  name="representacion"
                  formik={formik}>
                  <option value="">Seleccione</option>
                  <option value={`${GREMIOS.ATE}`}>{GREMIOS.ATE}</option>
                  <option value={`${GREMIOS.UPCN}`}>{GREMIOS.UPCN}</option>
                  <option value={`${GREMIOS.MINMUJ}`}>{GREMIOS.MINMUJ}</option>
                  <option value={`${GREMIOS.MINTRA}`}>{GREMIOS.MINTRA}</option>
                </CampoFormik>
              )}
            </Form.Group>
          </Form.Row>
          <br />
          <Form.Row>
            <Col>
              <Form.Group>
                <Form.Label style={{ display: 'block' }}>CUIT/CUIL</Form.Label>
                <Form.Control
                  style={{
                    display: 'inline-block',
                    marginRight: 10,
                    width: '50%',
                  }}
                  name="cuil"
                  value={formik.values.cuil}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={!!formik.errors.cuil}
                />
                <div style={{ display: 'inline-block' }}>
                  <Button variant="primary" onClick={(ev) => handleSearch(formik)}>
                    <i className="fa fa-fw fa-search"></i>
                  </Button>
                  <AjaxFeedback
                    status={ajaxFeedback}
                    style={{ position: 'absolute', marginLeft: 15 }}
                  />
                </div>
                <Form.Control.Feedback type="invalid">{formik.errors.cuil}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Form.Row>
          <fieldset disabled={disabled}>
            <Form.Row>
              <CampoFormik name="apellido" label="Apellido" formik={formik} />
              <CampoFormik name="nombre" label="Nombre" formik={formik} />
            </Form.Row>
            <Form.Row>
              <CampoFormik name="dni" label="DNI" formik={formik} />
              <CampoFormik name="telefono" label="Teléfono" formik={formik} />
            </Form.Row>
            <Form.Row>
              <CampoFormik name="email" label="Correo electrónico" formik={formik} />
            </Form.Row>
          </fieldset>
          {uploadCv && (
            <Form.Group as={Col}>
              <CampoFormik
                type="file"
                label="CV"
                name="cv"
                accept="application/pdf"
                formik={formik}
              />
              <Form.Text className="help-block" style={{ fontSize: 12 }}>
                Debe incluir solamente archivo en formato PDF
              </Form.Text>
            </Form.Group>
          )}
        </Form>
      )}
    </Formik>
  );
};

const AjaxFeedback = ({ style, status }) => {
  const containerStyle = { display: 'inline-block' };
  return (
    <div style={{ ...containerStyle, ...style }}>
      {status === 'pending' && <Spinner animation="border" variant="primary" />}
      <Fade in={status === 'success'} mountOnEnter unmountOnExit>
        <i className="fa fa-check text-success" style={{ fontSize: 24 }}></i>
      </Fade>
      <Fade in={status === 'error'} mountOnEnter unmountOnExit>
        <i className="fa fa-times text-danger" style={{ fontSize: 24 }}></i>
      </Fade>
    </div>
  );
};

export default NuevoMiembroComite;
